import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import React from "react";

import css from "./section.module.scss";

type SectionProps = {
  title?: string;
  headerAdditionalContent?: JSX.Element;
  className?: string;
};

export const Section = ({
  title,
  headerAdditionalContent,
  children,
  className
}: React.PropsWithChildren<SectionProps>) => (
  <div className={classNames(css.mainContainer, className)}>
    {(title || headerAdditionalContent) && (
      <div className={css.header}>
        {title && (
          <Typography variant="h4" noMargin>
            {title}
          </Typography>
        )}
        {headerAdditionalContent}
      </div>
    )}
    {children}
  </div>
);
